import imbusSchluesselImage from "../../image/accessory/01_zubehoer_imbusschluessel-1080x810.jpg";
import deckelheberGrossImage from "../../image/accessory/02_zubehoer_deckelheber_gross-1080x810.jpg";
import deckelheberKleinImage from "../../image/accessory/20250403_145445HP.jpg";
import deckelheberSetMitKetteImage from "../../image/accessory/05_zubehoer_deckelheberset_mit_kette_1080x810.jpg";
import deckelheberSetOhneKetteImage from "../../image/accessory/07_zubehoer_deckelheberset-1080x810.jpg";
import verlaengerteDeckelheberImage from "../../image/accessory/DSC05511-Hompage.jpg";
import abhebeOeffnungGussImage from "../../image/accessory/DeckeliGuss-438x207.jpg"; // Verschlussdeckel für Abhebeöffnungen bei V2A Abdeckungen
import verschaubungV2AImage from "../../image/accessory/DeckeliImbus-438x207.jpg"; // Verschlussdeckel für Verschraubungsöffnungen bei V2A Deckeln
import abhebeOeffnungV2AImage  from "../../image/accessory/DeckeliV2A-438x207.jpg"; // Verschlussdeckel für Abhebeöffnungen bei Gussabdeckungen
import fettImage from "../../image/accessory/FettZuGuss-438x207.jpg"; // Universal Hochdruckfett für Guss Abdeckungen, Büchse à 850 g

export const accessoryRepository = [
    {
        title: "Imbusschlüssel",
        price: 42,
        articleNumber: "SCHLÜSSEL-IMB-M12",
        unit: "piece",
        minOrderQuantity: 1,
        image: imbusSchluesselImage,
    },
    {
        title: "Deckelheber gross",
        price: 275,
        articleNumber: "MM-DEC-HEB",
        unit: "piece",
        minOrderQuantity: 1,
        image: deckelheberGrossImage,
    },
    {
        title: "Deckelheber klein",
        price: 82,
        articleNumber: "MM-DEC-HEB3",
        unit: "piece",
        minOrderQuantity: 1,
        image: deckelheberKleinImage,
    },
    {
        title: "Deckelheber Set mit Kette",
        price: 820,
        articleNumber: "MM-DEC-HEB2",
        unit: "piece",
        minOrderQuantity: 1,
        image: deckelheberSetMitKetteImage,
    },
    {
        title: "Deckelheber Set ohne Kette",
        price: 648,
        articleNumber: "MM-DEC-HEB4",
        unit: "piece",
        minOrderQuantity: 1,
        image: deckelheberSetOhneKetteImage,
    },
    {
        title: "Verlängerte Deckelheber",
        price: 85,
        articleNumber: "MM-DEC-HEB6",
        unit: "piece",
        minOrderQuantity: 1,
        image: verlaengerteDeckelheberImage,
    },
    {
        title: "Universal Hochdruckfett für Guss Abdeckungen, Büchse à 850 gr",
        articleNumber: "MM-FETT",
        price: 20.0,
        unit: "piece",
        minOrderQuantity: 1,
        image: fettImage,
    },
    {
        title: "Verschlussdeckel für Abhebeöffnungen bei V2A Abdeckungen",
        articleNumber: "MM-VER-DEC",
        price: 0.45,
        unit: "piece",
        minOrderQuantity: 100,
        image: abhebeOeffnungV2AImage,
    },
    {
        title: "Verschlussdeckel für Verschraubungsöffnungen bei V2A Deckeln",
        articleNumber: "MM-VER-IMB",
        price: 0.25,
        unit: "piece",
        minOrderQuantity: 100,
        image: verschaubungV2AImage,
    },
    {
        title: "Verschlussdeckel für Abhebeöffnungen bei Gussabdeckungen",
        articleNumber: "MM-VER-DEC-D",
        price: 1.95,
        unit: "piece",
        minOrderQuantity: 50,
        image: abhebeOeffnungGussImage,
    }
];
